import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { NavCard } from '../NavCard';
import styles from './NavCardWrapper.module.css';
export function NavCardWrapper({ routes, isActive = true, 'data-testid': dataTestId }) {
    return (_jsx("div", { className: styles.wrapper, "data-testid": dataTestId ?? 'nav-card-wrapper', children: routes.map((route, index) => (_jsx(NavCard, { ...route, isActive: isActive, "data-testid": index.toString() }, route.route.toString()))) }));
}
